import Vue from 'vue';
import Vuex from 'vuex';
import storePlugins from "@/plugins/storePlugins";


Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [storePlugins],
  state: {
    company: "",
    layout: 'loading',
    menu: true,
    disableResizeSidebar: false,
    loading: false,
    loggedIn: false,
    loggedUsername: 'U',
    userData: null,
    externalBusiness:[],
    snackbarProps: {
      visible: false,
      bottom: false,
      color: 'info',
      left: false,
      multiline: true,
      right: true,
      timeout: 2000,
      top: true,
      vertical: false,
      title:"aaa",
      text: 'HEMOS ENVIADO UN CORREO AL EVALUADOR CON LOS ENLACES DE LLENADO DE LAS EVALUACIONES PENDIENTES DE RESPONDER'
    },
  },
  mutations: {
  },
  actions: {
    tstAction(){
      console.log("aa");
      //router.push('/about');
    },

    /**
     * Open snackbar with success status
     * @param {*} _ dispatch data
     * @param {string} message Message to show
     */
    snackbarSuccess(_,message){
      let finalMessaje = "";
      let title = "";
      if (typeof message === 'string' || message instanceof String){
        finalMessaje = message;
        
      }else{
        finalMessaje = message.message;
        title = message.title
      }

      this.state.snackbarProps.color = 'success'
      this.state.snackbarProps.text = finalMessaje;
      this.state.snackbarProps.title = title;
      this.state.snackbarProps.visible = true
    },
    
    /**
     * Open snackbar with error status
     * @param {*} _ dispatch data
     * @param {string} message Message to show
    */
   snackbarError(_,message, title){
     this.state.snackbarProps.visible = true
     this.state.snackbarProps.color = 'error'
     this.state.snackbarProps.text = message;
     this.state.snackbarProps.title = title;
    },
    
    snackbarNotification(_,message, title){
      this.state.snackbarProps.visible = true
      this.state.snackbarProps.color = 'info'
      this.state.snackbarProps.text = message;
      this.state.snackbarProps.title = title;
    },


  },
  modules: {
  }
})
